// extracted by mini-css-extract-plugin
module.exports = {"warningWrapper":"Warning_warningWrapper__2n22H","warningContainer":"Warning_warningContainer__2vHbJ"};